import React from 'react';
import Modal from '../../components/Modal';



const Formulario = props => (
  <Modal title={props.title} idModal='mantenimiento' isOpen={props.isOpen} closeModal={props.closeModal} modalSize='modal-dialog modal-lg'>
    <div className="card card-plain card-lg form-group">

                        <header className="fdv-section-head">
                          <h5 className="fdv-section-title">Descripción certificado</h5>

                          <div className="fdv-section-actions">
                            <button className="btn-clean pull-right" type="button" onClick={()=> props.editBtn()} >
                              <i className="ion-edit h6 c-cyan open"></i>
                            </button>
                          </div>
                        </header>

                        {
                          props.valueEdit === false?(
                          <div>
                            <h4 className="card-lg-title" style={{marginLeft:'20px'}}>{props.descripcion}</h4>
                            <br />
                          </div>
                          ):(
                            <div className="js-open">
                              <div className="form-group">
                                <div className='row'>
                                  <div className='col-md-6'>
                                    <input className='form-control' id='descripcion' name='descripcion' onChange={props.onChangeValue}  type='text' value={props.descripcion} />
                                  </div>
                                  <div className='col-md-4'>
                                    <div className='checkbox'>
                                      <label >
                                        <input type='checkbox' id='valueActive' name='valueActive' onChange={props.onChangeChecked} checked={props.valueActive} />
                                        <div className='checkbox-skin' />
                                      Activo
                                    </label>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            <div className="clearfix">
                              <button className="btn btn-return pull-left open" type="button" onClick={()=> props.editBtn()} >Cancelar</button>
                              <button className="btn btn-primary pull-right" type="button" onClick={()=> props.createAreaBtnGuardar(props.registroSelected.cod_chek)}>Guardar</button>
                            </div>
                            <br />
                          </div>
                          )
                        }

                        <table className='table table-hover'>
                            <thead className='table-head'>
                              <tr>
                                <th>DESCRIPCIÓN </th>
                                <th>ACTIVO</th>
                                <th>POR DEFECTO</th>
                              </tr>
                            </thead>
                            <tbody>

                               {
                          props.listaAreaAll.map((items,index)=>
                             <tr key={index}>
                                 <td><div className='form-group'><div className='checkbox' ><label>{items.des_area_vta}</label></div></div></td>    
                             
                                <td>
                                      <div className='form-group' style={{margin:'0px 25px'}}>
                                        <div className='checkbox' >
                                          <label>  
                                            <input type="checkbox" checked={items.ind_inactivo === 'N'? true:false} name={'checkbox' + items.cod_area_vta} onChange={()=>props.onChangeInactivo(items.cod_area_vta,items.ind_inactivo)} />
                                            <div class="checkbox-skin"/> 
                                          </label>
                                        </div>
                                      </div>
                                  </td>
                                  <td>
                                      <div className='form-group' style={{margin:'0px 25px'}}>
                                        <div className='checkbox' >
                                          <label>  
                                            <input type="checkbox" checked={items.ind_default === 'N'?true:false} name={'checkbox' + items.cod_area_vta} onChange={()=>props.onChangeDefault(items.cod_area_vta,items.ind_default)}/>
                                            <div class="checkbox-skin"/>  
                                          </label>
                                        </div>
                                      </div>
                                </td>
                             </tr>
                          )}                           
                           </tbody>
                        </table>
                  
    </div>   
    <div className='modal-actions'>
      <button className='btn btn-return' onClick={() => props.closeModal()}>Cancelar</button>
      
        <button className='btn btn-primary pull-right' onClick={() => props.create()}>Guardar</button> 
      
    </div>
  </Modal>
);

Formulario.defaultProps = {
  isOpen: false,
};

export default Formulario;



// WEBPACK FOOTER //
// ./src/pages/MantAreadeVenta/Formulario.js